enum Role {
  USER = 'USER',
  ADMIN = 'ADMIN',
}

export default Role;
